import axios from 'axios'

const request = axios.create({
    // baseURL: 'http://192.168.1.176:9090/api',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
    // baseURL: 'http://localhost:9090',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
    baseURL: '/api',  // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
    timeout: 5000
})
let token = '';
// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
//添加一个请求拦截器
request.interceptors.request.use(function (config) {
    console.log("进入拦截器");
    // let user = JSON.parse(window.sessionStorage.getItem('access-user'));
    // console.log("user->>>" + user);
    // if (user) {
    //     token = user.token;
    // }
    // config.headers.common['token'] = token;
    let uid = window.sessionStorage.getItem('uid');
    console.log("uid->>>" + uid);
    if (uid) {
        config.headers.common['uid'] = uid;
    }
    let identity = window.sessionStorage.getItem('identity');
    console.log("identity->>>" + identity);
    if (identity) {
        config.headers.common['identity'] = identity;
    }

    //console.dir(config);
    return config;
}, function (error) {
    console.log("进入拦截器-错误");
    // Do something with request error
    console.info("error: ");
    console.info(error);
    return Promise.reject(error);
});

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err' + error) // for debug
        return Promise.reject(error)
    }
)

// 以request暴露出去
export default request

